export const REQUIRED_FIELDS = {
    WAREHOUSE: "Warehouse selection is required",
    MATERIALS: "Please add at least one material",
    STATUS: "Status is required",
    COMMENTS: "Comments are required",
    GRN:"GRN code is required",
};

export const TOAST_MESSAGES = {
    GRN_CREATED: "GRN created successfully!",
    GRN_CREATION_FAILED: "Failed to create GRN",
    GRN_FETCH_FAILED: "Failed to fetch GRN",
    GRN_DELETED: "GRN deleted successfully!",
    GRN_DELETION_FAILED: "Failed to delete GRN",
    GRNMaterial_CREATED: "GRNMaterial created successfully!",
    GRNMaterial_CREATION_FAILED: "Failed to create GRNMaterial",
    GRNMaterial_FETCH_FAILED: "Failed to fetch GRNMaterial",
    Warehouse_CREATED: "Warehouse created successfully!",
    Warehouse_CREATION_FAILED: "Failed to create Warehouse",
    Warehouse_FETCH_FAILED: "Failed to fetch Warehouses",
    Product_CREATED: "Product created successfully!",
    Product_CREATION_FAILED: "Failed to create Product",
    Product_FETCH_FAILED: "Failed to fetch Product",
    UNKNOWN_ERROR: "Something went wrong",
    MATERIALS_EMPTY: "No materials added yet.",
    GRN_UPDATED: "GRN updated successfully!",
    GRN_UPDATING_FAILED: "GRN Updation failed",
    MRR_FETCH_FAILED:"failed to fetch MRR"
};

export const GRN_STATUS = [
    { value: "Returned", label: "Returned" },
    { value: "Received", label: "Received" },
];

export const GRNMaterial_Condition = [
    { value: "GOOD", label: "Good" },
    { value: "DAMAGE", label: "Damage" },
    { value: "PARTIALLY_DAMAGE", label: "Partially Damage" },
];

export const GRN_MATERIAL_DEFAULT_VALUES = {
    product_id: null,
    product_name: "",
    quantity: 1,
    product_condition: "GOOD",
    comments: "",
};

export const GRN_LIST_COLUMNS = [
    "name",
    "id",
    "mrr",
    "status",
    "created",
    "created_by",
    "action",
    
];

export const GRN_LIST_LABELS = {
    name: "Warehouse",
    id: "GRN No",
    mrr: "MRR",
    status: "Status",
    created: "Raised On",
    created_by: "Raised By", 
    action: "Action",
    
};

// Material table columns
export const GRN_MATERIAL_COLUMNS = [
    "product_name",
    "product_condition",
    "quantity",
    "comments",
    "actions"
];

export const GRN_MATERIAL_LABELS = {
    product_name: "Product Name",
    product_condition: "Product Condition",
    quantity: "Total Quantity",
    comments: "Comments",
    actions:"Actions",
};
// GRN Details table columns
export const GRN_DETAIL_COLUMNS = [
    "product_name",
    "product_condition",
    "quantity",
    "comments",
];

export const GRN_DETAIL_LABELS = {
    product_name: "Product Name",
    product_condition: "Product Condition",
    quantity: "Total Quantity",
    comments: "Comments",
};

export const FILTER_FIELDS = [
    {
        key: "warehouse",
        label: "Warehouse",
        type: "select",
        defaultOption: { value: "", label: "All Warehouses" },
        options: [] 
    },
    {
        key: "mrr",
        label: "MRR",
        type: "select",
        defaultOption: { value: "", label: "All MRRs" },
        options: [] 
    }
];

export const STATUS_CHOICES = [
    { value: "draft", label: "Draft" },
    { value: "pending_for_approval", label: "Pending for Approval" },
    { value: "approved", label: "Approved" },
    { value: "rejected", label: "Rejected" },
];

export const GRN_MODES = {
    EDIT: "edit",
    DELETE: "delete",
    VIEW: "view",
};


export const getGRNStatusColor = (status) => {
  switch (status) {
    case GRN_STATUS_NAMES.DRAFT:
      return "bg-gray-100 text-gray-700";
    case GRN_STATUS_NAMES.PENDING_FOR_APPROVAL:
      return "bg-blue-50 text-blue-500 transition-colors";
    case GRN_STATUS_NAMES.APPROVED:
      return "bg-green-50 text-green-500 transition-colors";
    case GRN_STATUS_NAMES.REJECTED:
      return "bg-red-50 text-red-500 transition-colors";
    case GRN_STATUS_NAMES.COMPLETED:
      return "bg-cyan-50 text-cyan-500 transition-colors";
    default:
      return "bg-white text-black transition-colors"; // fallback for unknown status
  }
};


export const GRN_STATUS_NAMES = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED",
};

export const GRN_STATUS_LABELS = {
  DRAFT: "Draft",
  PENDING_FOR_APPROVAL: "Pending for Approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  COMPLETED: "Completed",
};

export const GRN_STATUS_COLORS = {
    DRAFT: "bg-gray-100 text-gray-800",
    PENDING_FOR_APPROVAL: "bg-yellow-100 text-yellow-800",
    APPROVED: "bg-green-100 text-green-800",
    REJECTED: "bg-red-100 text-red-800",
}